export const getOrdinalNum = num => {
  let selector

  if (num <= 0) {
    selector = 4
  } else if ((num > 3 && num < 21) || num % 10 > 3) {
    selector = 0
  } else {
    selector = num % 10
  }

  return num + ['th', 'st', 'nd', 'rd', ''][selector]
}
